import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import React from "react";
const WhiteCard = ({ children }) => (_jsx(Box, Object.assign({ minW: { md: "420px" }, mt: "10", rounded: "lg", bg: { md: "white" }, px: { md: "6" }, py: "7", borderWidth: "thin", borderColor: "gray.200" }, { children: children })));
export default WhiteCard;
